import { render, staticRenderFns } from "./settingsPosTable.vue?vue&type=template&id=03740b34&scoped=true&"
import script from "./settingsPosTable.vue?vue&type=script&lang=js&"
export * from "./settingsPosTable.vue?vue&type=script&lang=js&"
import style0 from "./settingsPosTable.vue?vue&type=style&index=0&id=03740b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03740b34",
  null
  
)

export default component.exports